<!-- 新建关联表单 -->
<template>
  <div class="item-select" v-clickoutside="handleBlur" :class="{'disable': item.nonEditable === 1}">

    <el-autocomplete
      v-if="!form[item.attr].id && (JSON.stringify(form[item.attr]) === '{}' || form[item.attr].length === 0)"
      :disabled="multiselect"
      v-model="itemValue"
      :fetch-suggestions="querySearchAsync"
      :placeholder="multiselect ? '请点击“选择”添加' : '请输入名称搜索或点击“选择”添加'"
      @select="selectedChecked"
    ></el-autocomplete>

    <template v-if="multiselect && form && form[item.attr]">
      <span class="item" v-for="(formItem, i) in form[item.attr]" :key="formItem.id">
        <span class="text">{{formItem.value}}</span>
        <i class="del el-icon-close" @click="del(i)"></i>
      </span>
    </template>
    <span class="item" v-if="!multiselect && form && form[item.attr].id" >
      <span class="text">{{form[item.attr].value}}</span>
      <i class="del el-icon-close" @click="del()"></i>
    </span>
    <el-button type="text" class="select-btn" @click="handleSelect(module)">选择</el-button>
    <transition name="slide" v-if="showAssociated">
      <associated-new
        ref="associatedNew"
        :module="module"
        :item="item"
        :fromMoudle="fromMoudle"
        :customerId="customerId"
        :attrValue="formatAttrValue(form[item.attr])"
        :multiselect="multiselect"
        @close="showAssociated = false"
        @emitObj="emitObj"
        @addNew="addNew">
      </associated-new>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="showAssociated" @click.stop="detailShow=false"></div>
    </transition>
  </div>
</template>
<script>
import * as api from 'src/api'
import { mapActions } from 'vuex'
import associatedNew from '../modal/associated-new'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
const dataMap = {
  customerApi: '/customerApi/getCustomers.html',
  contactApi: '/contactApi/getContacts.html',
  contractApi: '/contractApi/getContractList.html',
  supplier: '/supplier/getSupplierList.html',
  purchase: '/purchase/getPurchaseList.html',
  opportunityApi: '/opportunityApi/getOpportunitys.html'
}

export default {
  props: ['module', 'item', 'form', 'customerId', 'multiselect', 'fromMoudle'],
  data () {
    return {
      showAssociated: false,
      addnewShow: false,
      repeatListShow: false,
      addnewProp: {},
      itemValue: '',
      timeout: null // 计时器
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
  // 打开关联弹框
    handleSelect () {
      this.repeatListShow = false
      this.showAssociated = true
    },
    emitObj (data) {
      let emitData = ''
      if (this.form && data.length > 0) {
        if (this.multiselect) {
          emitData = data
        } else {
          if (data[0].id) {
            emitData = data[0]
          } else {
            emitData = ''
          }
        }
        this.form[this.item.attr] = emitData
      }
      this.showAssociated = false
      this.setAttr(this.item.attr)
      this.$emit('emitObj', emitData)
    },
    addNew (obj) {
      this.addnewProp = {
        module: this.module,
        templateId: obj.templateId ? obj.templateId : ''
      }
      if (['contractApi', 'contactApi', 'opportunityApi'].indexOf(this.module) > -1) {
        this.addnewProp.refId = this.customerId
        this.addnewProp.type = 'customerApi'
      }

      if (obj.module === 'purchase') {
        this.$emit('addNewPur', obj.module)
      } else if (obj.module === 'supplierContact') {
        // 新建供应商联系人
        this.addnewProp.supplierId = this.customerId
        this.addnewProp.module = obj.module
        this.$emit('addNew', this.addnewProp)
      } else {
        this.$emit('addNew', this.addnewProp)
      }
    },
    refresh () {
      if (this.$refs.associatedNew) {
        this.$refs.associatedNew.getUserList()
      }
    },
    // 删除已选项
    del (i) {
      if (this.multiselect) {
        this.form[this.item.attr].splice(i, 1)
      } else {
        this.form[this.item.attr] = ''
      }
      this.itemValue = ''
      this.$emit('emitObj', this.form[this.item.attr])
      this.setAttr(this.item.attr)
    },
    querySearchAsync (queryString, cb) {
      clearTimeout(this.timeout)
      queryString = queryString.trim()
      if (!queryString) {
        cb([])
        return
      }
      this.timeout = setTimeout(() => {
        let url = dataMap[this.module]
        let params = {
          nameLike: queryString
        }
        if (this.customerId) {
          params.customerId = this.customerId
        }
        api.post(url, params, (data) => {
          cb(data.result)
        })
      }, 3000 * Math.random())
    },
    selectedChecked (item) {
      this.form[this.item.attr] = {
        id: item.id,
        value: item.value
      }
      if (this.module === 'customerApi') {
        this.form[this.item.attr].key = item.type
      }
      this.setAttr(this.item.attr)
      this.repeatListShow = false
      this.$emit('emitObj', this.form[this.item.attr])
    },
    handleBlur () {
      if (!this.form[this.item.attr].id && !this.multiselect) {
        this.form[this.item.attr] = ''
        this.repeatListShow = false
      }
    },
    formatAttrValue (value) {
      if (this.multiselect) {
        return value || []
      } else {
        return value ? [value] : []
      }
    },
    // 跟进记录当类型为40的时候的客户状态
    selectHandle (attr) {
      this.form[this.item.attr].position = this.item.secondControl.attrValue
    }
  },
  components: {
    associatedNew
  },
  directives: { Clickoutside }
}
</script>
<style lang="less" scoped>
@import '../../assets/less/remote-select.less';
  .item-select {
    .select-btn {
      right: 0px;
      background: #fff;
      padding-right: 10px;
      padding-left: 10px;
    }
    .detail-bg {
      top: 0;
    }
    &.disable {
      background-color: #eef1f6;
      border: 1px solid #d1dbe5;
      color: #bbb;
      .select-btn {
        background-color: transparent;
      }
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
        cursor: not-allowed;
      }
    }
  }
  .repeat-list {
    position: absolute;
    width: 250px;
    max-height: 300px;
    background-color: #fff;
    z-index: 100;
    overflow: auto;
    box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
    left: 2px;
    top: 40px;
    .title {
      font-size: 14px;
      line-height: 32px;
      border-bottom: 1px solid #ededed;
      padding-left: 10px;
    }
    .repeat-item {
      cursor: pointer;
      line-height: 28px;
      padding: 0 10px;
      color: #888;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
<style lang="less">
  .remote-select {
    .el-form-item__content {
      overflow: hidden;
    }
  }
  .item-select {
    .el-autocomplete {
      width: 100%;
      .el-input.is-disabled .el-input__inner {
        background-color: #fff;
      }
    }
    &.disable {
      .el-input__inner {
        background-color: transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// associated-field.vue?2b380d54